import * as yup from "yup";
import { FormInputMeta } from "@Modules/core/types/FormMetaType";
import { getValidationSchema } from "@Shared/utils/validationSchema";

export interface IATMTransactionInquiryDataTableRowFormMeta {
  typeCard: FormInputMeta,
  terminalID: FormInputMeta,
  oneDate: FormInputMeta,
  cardNumber: FormInputMeta,
  serialNumber: FormInputMeta,
  amount: FormInputMeta,
  currency: FormInputMeta,
  status: FormInputMeta,
  
  schema: any,
}

const ATMTransactionInquiryDataTableRowFormMeta = {} as IATMTransactionInquiryDataTableRowFormMeta;

ATMTransactionInquiryDataTableRowFormMeta.typeCard = {
  name: "typeCard",
  type: "text",
  label: "Type",
  placeholder: "",
  validation: yup.date().required("Champ obligatoire !")
};

ATMTransactionInquiryDataTableRowFormMeta.terminalID = {
  name: "terminalID",
  type: "text",
  label: "Terminal ID",
  placeholder: "",
  validation: yup.date().required("Champ obligatoire !")
};

ATMTransactionInquiryDataTableRowFormMeta.oneDate = {
  name: "oneDate",
  type: "date",
  label: "Date",
  placeholder: "",
  validation: yup.date().required("Champ obligatoire !")
};

ATMTransactionInquiryDataTableRowFormMeta.cardNumber = {
  name: 'cardNumber',
  type: 'text',
  label: 'Numero Carte',
  placeholder: '',
  validation: yup.string().required(),
};

ATMTransactionInquiryDataTableRowFormMeta.serialNumber = {
  name: "serialNumber",
  type: "text",
  label: "Serial Number",
  placeholder: "",
  validation: yup.date().required("Champ obligatoire !")
};

ATMTransactionInquiryDataTableRowFormMeta.amount = {
  name: "amount",
  type: "text",
  label: "Montant",
  placeholder: "",
  validation: yup.date().required("Champ obligatoire !")
};

ATMTransactionInquiryDataTableRowFormMeta.currency = {
  name: "currency",
  type: "text",
  label: "Current",
  placeholder: "",
  validation: yup.date().required("Champ obligatoire !")
};

ATMTransactionInquiryDataTableRowFormMeta.status = {
  name: "status",
  type: "text",
  label: "Statut",
  placeholder: "",
  validation: yup.date().required("Champ obligatoire !")
};

ATMTransactionInquiryDataTableRowFormMeta.schema = yup.object().shape(getValidationSchema(ATMTransactionInquiryDataTableRowFormMeta));

export default ATMTransactionInquiryDataTableRowFormMeta;
